import React, { Component } from 'react';
import autoBind from 'react-autobind';
import { connect } from 'react-redux';
import { asyncRequest, Entities, fetchById, SanitizedInnerHTML, search, TOMCAT_URL } from 'src/common';
import CircularProgress from 'material-ui/CircularProgress';
import { addErrorNotification } from 'src/actions/notifications';
import EmailToJourneyForm from 'src/components/administration/email-to-journey/components/email-to-journey-form';

class EmailToJourneyEditModal extends Component {
    constructor(props) {
        super(props);
        autoBind(this);

        this.state = {
            startedFetching: false,
            showFormResult: false,
            loading: false,
            offerUrl: null,
            isError: false,
        };
    }

    callSubmit() {
        return this.childForm.submit();
    }

    didFormChange() {
        return !this.childForm.pristine;
    }

    render() {
        const { loading, offerUrl, isError, showFormResult } = this.state;
        const { t } = this.props;

        return (
            <div className="col-md-12">
                {loading && (
                    <>
                        <div
                            className="col-md-12"
                            style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <CircularProgress /> <p>{t('email_to_journey.processing')}</p>
                        </div>
                    </>
                )}
                {!loading && offerUrl == null && !isError && (
                    <>
                        <p>
                            <SanitizedInnerHTML html={t('email_to_journey.how_to')} />
                        </p>
                        <EmailToJourneyForm
                            onSubmit={this.handleSubmit}
                            ref={ref => (this.childForm = ref)}
                            t={this.props.t}
                            offerUrl={offerUrl}
                        />
                    </>
                )}
                {showFormResult && (
                    <>
                        <div className="row col-md-12">
                            <p>
                                <span>{t('email_to_journey.request_successful')} &nbsp;</span>
                                <button
                                    className="btn btn-primary"
                                    onClick={() => {
                                        const win = window.open(this.state.offerUrl, '_blank');
                                        if (win != null) win.focus();
                                    }}>
                                    {t('email_to_journey.create_offer')}
                                </button>
                            </p>
                        </div>
                    </>
                )}
                {isError && (
                    <div>
                        <p>{t('email_to_journey.errors.on_form_submit')}</p>
                    </div>
                )}
                <div>
                    {!isError && !showFormResult && (
                        <button
                            className="btn pull-right btn-primary"
                            style={{ marginBottom: 10, marginLeft: 10 }}
                            type="submit"
                            disabled={loading}
                            onClick={() => {
                                this.childForm.submit();
                            }}>
                            {t('email_to_journey.form.submit')}
                        </button>
                    )}

                    {(isError || offerUrl != null) && (
                        <button
                            className="btn pull-right btn-primary"
                            style={{ marginBottom: 10, marginLeft: 10 }}
                            type="submit"
                            onClick={() => {
                                this.setState({ showFormResult: false, offerUrl: null, isError: false });
                            }}>
                            {t('email_to_journey.form.new_request')}
                        </button>
                    )}

                    <button
                        className="btn pull-right secondary"
                        style={{ marginBottom: 10 }}
                        onClick={() => {
                            this.props.refetch();
                            this.props.handleClose();
                        }}>
                        {t('find_my_bus.close_modal')}
                    </button>
                </div>
            </div>
        );
    }

    handleSubmit(data) {
        this.setState({ loading: true });
        asyncRequest({
            method: 'POST',
            endpoint: `${TOMCAT_URL}api/${Entities.EMAIL_TO_OFFER.repository}/get-journey`,
            body: {
                email: data.emailInput,
                internalReference: data.internalReference,
            },
        })
            .then(response => {
                this.setState({ offerUrl: response.json.url, showFormResult: true, loading: false });
            })
            .catch(error => {
                this.props.addErrorNotification({ code: error.status, message: error.statusText });
                this.setState({ loading: false, isError: true });
            });
    }
}

const mapStateToProps = (state, ownProps) => {
    return {};
};

export default connect(
    mapStateToProps,
    {
        fetchById,
        search,
        addErrorNotification,
    },
    null,
    { withRef: true },
)(EmailToJourneyEditModal);
